import {ComparedTo} from "doctors-dashboard/http-clients/index";
import {PatientTemperatureOption} from "../interfaces/patient-temperature-option";

export const PatientTemperatureComparedTo: PatientTemperatureOption<ComparedTo>[] = [
    {name: 'Contralateral foot', value: ComparedTo.Contralateral},
    {name: 'Ipsilateral foot', value: ComparedTo.Ipsilateral},
];